export const ADD_SURVEY_TEMPLATE_DATA_REQUEST = "ADD_SURVEY_TEMPLATE_DATA_REQUEST";
export const ADD_SURVEY_TEMPLATE_DATA_SUCCESS = "ADD_SURVEY_TEMPLATE_DATA_SUCCESS";
export const ADD_SURVEY_TEMPLATE_DATA_FAILURE = "ADD_SURVEY_TEMPLATE_DATA_FAILURE";

export const UPDATE_SURVEY_TEMPLATE_DATA_REQUEST = "UPDATE_SURVEY_TEMPLATE_DATA_REQUEST";
export const UPDATE_SURVEY_TEMPLATE_DATA_SUCCESS = "UPDATE_SURVEY_TEMPLATE_DATA_SUCCESS";
export const UPDATE_SURVEY_TEMPLATE_DATA_FAILURE = "UPDATE_SURVEY_TEMPLATE_DATA_FAILURE";

export const GET_SURVEY_TEMPLATE_SUCCESS = "GET_SURVEY_TEMPLATE_SUCCESS";
export const GET_SURVEY_TEMPLATE_REQUEST = "GET_SURVEY_TEMPLATE_REQUEST";
export const GET_SURVEY_TEMPLATE_FAILURE = "GET_SURVEY_TEMPLATE_FAILURE";

export const UPDATE_SURVEY_TEMPLATE_ENTITY_PARAMS_SUCCESS = "UPDATE_SURVEY_TEMPLATE_ENTITY_PARAMS_SUCCESS";
export const UPDATE_SURVEY_TEMPLATE_ENTITY_PARAMS_FAILURE = "UPDATE_SURVEY_TEMPLATE_ENTITY_PARAMS_FAILURE";

export const DELETE_SURVEY_TEMPLATE_REQUEST = "DELETE_SURVEY_TEMPLATE_REQUEST";
export const DELETE_SURVEY_TEMPLATE_SUCCESS = "DELETE_SURVEY_TEMPLATE_SUCCESS";
export const DELETE_SURVEY_TEMPLATE_FAILURE = "DELETE_SURVEY_TEMPLATE_FAILURE";

export const GET_SURVEY_TEMPLATE_BY_ID_REQUEST = "GET_SURVEY_TEMPLATE_BY_ID_REQUEST";
export const GET_SURVEY_TEMPLATE_BY_ID_SUCCESS = "GET_SURVEY_TEMPLATE_BY_ID_SUCCESS";
export const GET_SURVEY_TEMPLATE_BY_ID_FAILURE = "GET_SURVEY_TEMPLATE_BY_ID_FAILURE";

export const GET_DEFAULT_SURVEY_TEMPLATE_REQUEST = "GET_DEFAULT_SURVEY_TEMPLATE_REQUEST";
export const GET_DEFAULT_SURVEY_TEMPLATE_SUCCESS = "GET_DEFAULT_SURVEY_TEMPLATE_SUCCESS";
export const GET_DEFAULT_SURVEY_TEMPLATE_FAILURE = "GET_DEFAULT_SURVEY_TEMPLATE_FAILURE";

export const RESET_TEMPLATE_REDUCER = "RESET_TEMPLATE_REDUCER";

export const GET_SURVEY_TEMPLATE_EXPORT_REQUEST = "GET_SURVEY_TEMPLATE_EXPORT_REQUEST";
export const GET_SURVEY_TEMPLATE_EXPORT_SUCCESS = "GET_SURVEY_TEMPLATE_EXPORT_SUCCESS";
export const GET_SURVEY_TEMPLATE_EXPORT_FAILURE = "GET_SURVEY_TEMPLATE_EXPORT_FAILURE";

export const GET_ENTITY_TEMPLATE_DROPDOWN_REQUEST = "GET_ENTITY_TEMPLATE_DROPDOWN_REQUEST";
export const GET_ENTITY_TEMPLATE_DROPDOWN_SUCCESS = "GET_ENTITY_TEMPLATE_DROPDOWN_SUCCESS";
export const GET_ENTITY_TEMPLATE_DROPDOWN_FAILURE = "GET_ENTITY_TEMPLATE_DROPDOWN_FAILURE";

export const RESET_GLOBAL_ADC_TABLE_DATA_SUCCESS = "RESET_GLOBAL_ADC_TABLE_DATA_SUCCESS";
export const RESET_GLOBAL_ADC_TABLE_DATA_FAILURE = "RESET_GLOBAL_ADC_TABLE_DATA_FAILURE";

export const staticFields = [
    "asset_name",
    "asset_note",
    "asset_tag",
    "installed_year",
    "service_life",
    "usefull_life_remaining",
    "crv",
    "manufacturer",
    "model_number",
    "serial_number",
    "capacity",
    "area_served",
    "room_number",
    "room_name",
    "architectural_room_number",
    "additional_room_description",
    "asset_description",
    "asset_type_id",
    "asset_barcode",
    "asset_client_id",
    "asset_cmms_id",
    "warranty_start",
    "warranty_end",
    "install_date",
    "startup_date",
    "upstream_asset_barcode_number",
    "linked_asset_barcode_number",
    "source_panel_barcode_number",
    "source_panel",
    "asset_status_id",
    "notes",
    "region_id",
    "site_id",
    "building_id",
    "main_building_type_id",
    "floor_id",
    "addition_id",
    "uniformat_level_1_id",
    "uniformat_level_2_id",
    "uniformat_level_3_id",
    "uniformat_level_4_id",
    "uniformat_level_5_id",
    "location",
    "year_manufactured",
    "criticality",
    // "image_id",
    // "code",
    "custom_id",
    // "client_id",
    // "guid",
    "main_category_id",
    "sub_category_1_id",
    "sub_category_2_id",
    "sub_category_3_id",
    "client_asset_condition_id",
    "est_replacement_cost",
    "source_panel_name",
    "skysite_hyperlink",
    "trade_id",
    "sub_system_id",
    "system_id",
    "fca_cost",
    "capacity_unit",
    "quantity",
    "uniformat_level_6_id",
    "rtls_tag",
    // "latitude",
    // "longitude",
    "current_age",
    "age",
    "new_asset",
    "parent_global_id",
    "survey_global_id",
    "survey_id",
    "survey_property_note",
    "capacity_status",
    "installed_year_status",
    "name_plate_status",
    "qa_notes",
    "additional_qa_notes",
    "surveyor",
    "editor",
    "survey_date_created",
    "survey_date_edited",
    "asset_condition_notes",
    "category_description",
    "core_model_number",
    // "id",
    // "created_at",
    // "updated_at",
    "client_asset_condition__description",
    "asset_ownership",
    "csp_unit",
    "refrigerant",
    "energy_use_type",
    "unit_cost",
    "end_of_service_life",
    "client_standards_id",
    "client_standards__description",
    "asset_additionals.boiler_type",
    "asset_additionals.boiler_burner_type",
    "asset_additionals.boiler_btu_input",
    "asset_additionals.boiler_btu_output",
    "asset_additionals.boiler_hp",
    "asset_additionals.boiler_fuel",
    "asset_additionals.boiler_gas_pressure",
    "asset_additionals.boiler_kw_input",
    "asset_additionals.boiler_power_burner_type",
    "asset_additionals.boiler_burner_model",
    "asset_additionals.boiler_burner_serial",
    "asset_additionals.unit_property_labeled",
    "asset_additionals.ahu_voltage",
    "asset_additionals.estimated_wire_run_length",
    "asset_additionals.mca",
    "asset_additionals.hot_gas_by_pass",
    "asset_additionals.damper_type",
    "asset_additionals.electric_heating",
    "asset_additionals.cooling_only",
    "asset_additionals.smoke_detector",
    "asset_additionals.smoke_detector_return",
    "asset_additionals.vibration_isolation",
    "asset_additionals.curb_outside_dimension_length",
    "asset_additionals.ducted_or_concentric_system",
    "asset_additionals.boiler_pressure_type",
    "asset_additionals.discharge",
    "asset_additionals.factory_mounted_disconnect",
    "asset_additionals.wire_type",
    "asset_additionals.breaker_size",
    "asset_additionals.liquid_line",
    "asset_additionals.number_of_circuits",
    "asset_additionals.gas_heating",
    "asset_additionals.electric_heating_kw",
    "asset_additionals.controls",
    "asset_additionals.smoke_detector_mounting",
    "asset_additionals.curb",
    "asset_additionals.burglar_bars",
    "asset_additionals.curb_outside_dimension_width",
    "asset_additionals.confirm_boiler_pressure",
    "asset_additionals.return",
    "asset_additionals.unit_voltage",
    "asset_additionals.wire_size",
    "asset_additionals.mocp",
    "asset_additionals.suction_line",
    "asset_additionals.length_of_line",
    "asset_additionals.gas_output_btu",
    "asset_additionals.pump_backup_heat_kw",
    "asset_additionals.control_type",
    "asset_additionals.smoke_detector_supply",
    "asset_additionals.curb_description",
    "asset_additionals.installed_on_adapter_curb",
    "asset_additionals.allow_curb_adaptor",
    "asset_additionals.unit_weight",
    "asset_additionals.codes_for_roof_lighting",
    "asset_additionals.code_or_safety_concerns",
    "asset_additionals.need_resealed",
    "asset_additionals.split_system_line_sets_crimped",
    "asset_additionals.line_connection_type",
    "asset_additionals.codes_for_disconnects",
    "asset_additionals.duct_work_attached_to_bottom_of_unit",
    "asset_additionals.distance_from_salt_water_body",
    "asset_additionals.split_system_line_sets_good_condition",
    "asset_additionals.split_system_line_sets_insulated",
    "asset_additionals.codes_for_convenience_outlets",
    "asset_additionals.aluminium_wire_used",
    "asset_additionals.recommend_coil_coating",
    "asset_additionals.split_system_line_sets_damaged",
    "asset_additionals.split_system_line_sets_re_used",
    "asset_auxiliaries.auxiliary_equipment_name",
    "asset_auxiliaries.auxiliary_model",
    "asset_auxiliaries.auxiliary_serial",
    "asset_auxiliaries.auxiliary_date_manufactured",
    "asset_auxiliaries.auxiliary_manufacturer",
    "asset_auxiliaries.auxiliary_condition",
    "asset_auxiliaries.auxiliary_eul",
    "asset_auxiliaries.auxiliary_crv",
    "cs_l1_type_id",
    "cs_l2_category_id",
    "cs_l3_subsystem_id",
    "cs_l4_object_id",
    "cs_l5_equipment_config_id"
];

export const customSelectFields = [
    "trade_id",
    "sub_system_id",
    "system_id",
    "main_category_id",
    "sub_category_1_id",
    "sub_category_2_id",
    "sub_category_3_id",
    "manufacturer",
    "asset_type_id",
    "region_id",
    "site_id",
    "building_id",
    "floor_id",
    "addition_id",
    "uniformat_level_1_id",
    "uniformat_level_2_id",
    "uniformat_level_3_id",
    "uniformat_level_4_id",
    "uniformat_level_5_id",
    "uniformat_level_6_id",
    "client_asset_condition_id",
    "main_building_type_id",
    "client_asset_condition__description",
    "asset_status_id",
    "client_standards_id",
    "cs_l1_type_id",
    "cs_l2_category_id",
    "cs_l3_subsystem_id",
    "cs_l4_object_id",
    "cs_l5_equipment_config_id"
];

export const intFields = [
    "installed_year",
    "service_life",
    "usefull_life_remaining",
    "crv",
    "custom_id",
    "est_replacement_cost",
    "fca_cost",
    "quantity",
    "recommendation_count",
    "end_of_service_life",
    "year_manufactured",
    "current_age",
    "age",
    "unit_cost"
];

export const dateFields = ["warranty_start", "warranty_end", "install_date", "startup_date"];
export const hierarchyDependecyField = [
    "assets.region_id",
    "assets.site_id",
    "assets.building_id",
    "assets.uniformat_level_1_id",
    "assets.uniformat_level_2_id",
    "assets.uniformat_level_3_id",
    "assets.uniformat_level_4_id",
    "assets.uniformat_level_6_id",
    "assets.client_standards_id",
    "assets.main_category_id",
    "assets.sub_category_1_id",
    "assets.sub_category_2_id",
    "assets.sub_category_3_id",
    "assets.trade_id",
    "assets.sub_system_id",
    "assets.system_id",
    "assets.current_age",
    "assets.end_of_service_life",
    "assets.cs_l1_type_id",
    "assets.cs_l2_category_id",
    "assets.cs_l3_subsystem_id",
    "assets.cs_l4_object_id",
    "assets.cs_l5_equipment_config_id",
    "assets.installed_year",
    "assets.service_life",
    "assets.usefull_life_remaining",
    "assets.floor_id",
    "assets.addition_id",
    "assets.uniformat_level_5_id",
    "assets.end_of_service_life",
    "buildings.main_building_type_id",
    "assets.client_asset_condition__description",
    "buildings.description",
    "main_building_type_id",
    "assets.client_standards__description"
];
export const ASSET_DEPENDENCY_FIELDS = {
    "assets.region_id": ["assets.site_id", "assets.building_id", "assets.floor_id", "assets.addition_id", "buildings.description"],
    "assets.site_id": ["assets.building_id", "assets.floor_id", "assets.addition_id", "buildings.description"],
    "assets.building_id": ["assets.floor_id", "assets.addition_id"],
    "assets.trade_id": ["assets.system_id", "assets.sub_system_id"],
    "assets.system_id": ["assets.sub_system_id"],
    "buildings.main_building_type_id": ["assets.building_id", "assets.floor_id", "assets.addition_id"]
};

export const UNIFORMAT_LEVELS = [
    "assets.uniformat_level_6_id",
    "assets.uniformat_level_5_id",
    "assets.uniformat_level_4_id",
    "assets.uniformat_level_3_id",
    "assets.uniformat_level_2_id",
    "assets.uniformat_level_1_id"
];

export const CLIENT_STANDARD_KEYS = {
    "assets.csp_unit": "assets.csp_unit",
    "assets.service_life": "assets.service_life",
    "assets.client_standards__description": "description",
    "assets.uniformat_level_1_id": "uniformat_level_1_id",
    "assets.uniformat_level_2_id": "uniformat_level_2_id",
    "assets.uniformat_level_3_id": "uniformat_level_3_id",
    "assets.uniformat_level_4_id": "uniformat_level_4_id",
    "assets.uniformat_level_5_id": "uniformat_level_5_id",
    "assets.uniformat_level_6_id": "uniformat_level_6s_id"
};

export const CS_ENTITY_LEVELS = [
    "entity",
    "assets.survey_target_id",
    "assets.cs_l1_type_id",
    "assets.cs_l2_category_id",
    "assets.cs_l3_subsystem_id",
    "assets.cs_l4_object_id",
    "assets.cs_l5_equipment_config_id",
    "assets.asset_name"
];

export const CS_BASE_LEVELS = [
    "entity",
    "assets.survey_target_id",
    "assets.cs_l1_type_id",
    "assets.cs_l2_category_id",
    "assets.cs_l3_subsystem_id",
    "assets.cs_l4_object_id",
    "assets.cs_l5_equipment_config_id",
    "assets.uniformat_level_6_id",
    "assets.uniformat_level_5_id",
    "assets.uniformat_level_4_id",
    "assets.uniformat_level_3_id",
    "assets.uniformat_level_2_id",
    "assets.uniformat_level_1_id",
    "assets.csp_unit",
    "assets.service_life",
    "assets.client_standards__description"
];

export const CS_HIERARCHY = [
    "assets.survey_target_id",
    "assets.cs_l1_type_id",
    "assets.cs_l2_category_id",
    "assets.cs_l3_subsystem_id",
    "assets.cs_l4_object_id",
    "assets.cs_l5_equipment_config_id",
    "assets.client_standards_id",
    "assets.asset_name"
];

export const GET_LIST_KEY = {
    region_id: "regions",
    site_id: "sites",
    building_id: "buildings",
    floor_id: "floors",
    addition_id: "additions",
    trade_id: "trades",
    system_id: "systems",
    sub_system_id: "sub_systems",
    manufacturer_id: "manufacturers",
    manufacturer: "manufacturers",
    asset_type_id: "asset_types",
    main_category_id: "main_categories",
    asset_status_id: "asset_statuses",
    client_asset_condition_id: "asset_conditions",
    asset_condition_id: "asset_conditions",
    main_building_type_id: "building_types",
    uniformat_level_1_id: "uniformat_level_1_id",
    uniformat_level_2_id: "uniformat_level_2_id",
    uniformat_level_3_id: "uniformat_level_3_id",
    uniformat_level_4_id: "uniformat_level_4_id",
    uniformat_level_5_id: "uniformat_level_5_id",
    uniformat_level_6_id: "uniformat_level_6_id",
    client_standards_id: "client_standards",
    cs_l1_type_id: "cs_l1_type_id",
    cs_l2_category_id: "cs_l2_category_id",
    cs_l3_subsystem_id: "cs_l3_subsystem_id",
    cs_l4_object_id: "cs_l4_object_id",
    cs_l5_equipment_config_id: "cs_l5_equipment_config_id",
    survey_target_id: "survey_target_id",
    entity: "survey_target_id",
    sub_category_1_id: "sub_category_1s",
    sub_category_2_id: "sub_category_2s",
    sub_category_3_id: "sub_category_3s"
};
